import React from 'react';
import { VStack } from '@adc/parallax-component-library';
const Main = ({ ...props }) => {
    const isDvhSupported = CSS?.supports?.('height', '1dvh');
    return (React.createElement(VStack, { backgroundColor: "$surface.background", style: [{ minHeight: '-webkit-fill-available', height: isDvhSupported ? '100dvh' : '100vh' }], ...props }));
};
export { Main };
